import { PAPER_SIZE } from '../../types/enums';
import { receiptA4Styles } from './ReceiptPDFA4.styles';

interface Props {
  size: PAPER_SIZE;
}

export const useReceiptPDF = ({ size }: Props) => {
  const getPageSize = () => {
    if(size === PAPER_SIZE.A4) {
      return PAPER_SIZE.A4;
    }
    if(size === PAPER_SIZE.FOUR_X_TEN_INCH) {
      return { width: '4in', height: '10in' };
    }
    if(size === PAPER_SIZE.W105xH140mm) {
      return { width: '105mm', height: '140mm' };
    }
    return PAPER_SIZE.A4;
  };

  const getLogoStyles = () => {
    if(size === PAPER_SIZE.FOUR_X_TEN_INCH) {
      return receiptA4Styles.logo4x10;
    }
    if(size === PAPER_SIZE.W105xH140mm) {
      return receiptA4Styles.logo105x140;
    }
    if(size === PAPER_SIZE.A4) {
      return receiptA4Styles.logo;
    }
    return {};
  };

  const getMainWrapperStyles = () => {
    if(size === PAPER_SIZE.FOUR_X_TEN_INCH) {
      return receiptA4Styles.mainContainer4x10;
    }
    if(size === PAPER_SIZE.W105xH140mm) {
      return receiptA4Styles.mainContainer105x140;
    }
    if(size === PAPER_SIZE.A4) {
      return receiptA4Styles.mainContainer;
    }
    return {};
  };

  const getPaymentsInfoStyles = () => {
    if(size === PAPER_SIZE.FOUR_X_TEN_INCH) {
      return receiptA4Styles.paymentsInfo4x10;
    }
    if(size === PAPER_SIZE.W105xH140mm) {
      return receiptA4Styles.payments105x140mm;
    }
    if(size === PAPER_SIZE.A4) {
      return receiptA4Styles.paymentsInfo;
    }
    return {};
  };

  const getPaymentsLabelStyles = () => {
    if(size === PAPER_SIZE.FOUR_X_TEN_INCH) {
      return receiptA4Styles.paymentsSummary4x10;
    }
    if(size === PAPER_SIZE.A4) {
      return receiptA4Styles.paymentsSummary;
    }
    return {};
  };

  return {getPaymentsInfoStyles, getPaymentsLabelStyles, getLogoStyles, getPageSize, getMainWrapperStyles };
};
